import { Icd10CodeType } from '~/services/api/enums';

const icd10CodeTypeOrderings = [
  Icd10CodeType.Primary,
  Icd10CodeType.Secondary,
  Icd10CodeType.Other,
];

export default icd10CodeTypeOrderings;
